import cx from "classnames";
import React from "react";
import Job from "./Job";
import Section from "../Section";

const Portfolio: React.FC = (): React.ReactElement => (
  <Section className="u-background-color-secondary" id="Samples">
    <div
      className={cx([
        "u-margin-top-negative-0point875rem",
        "u-margin-bottom-negative-0point875rem",
      ])}
    >
      <div className="u-padding-0point875rem">
        <p
          className={cx([
            "u-color-text",
            "u-font-size-l",
            "u-line-height-s",
            "u-margin-bottom-3xs",
            "u-margin-top-0",
            "u-text-center",
            "u-text-normal",
          ])}
        >
          Work Samples
        </p>
        <hr
          className={cx([
            "u-border-color-text",
            "u-horizontal-rule",
            "u-margin-bottom-0",
          ])}
        />
      </div>
      <div
        className={cx([
          "u-flex",
          "u-flex-row",
          "u-flex-wrap",
          "u-justify-content-center",
          "u-margin-top-negative-0point875rem",
          "u-margin-bottom-negative-0point875rem",
          "u-padding-0point875rem",
        ])}
      >
        <div
          className={cx([
            "julia-website-portfolio",
            "u-flex",
            "u-flex-column",
            "u-padding-0point875rem",
          ])}
        >
          <Job
            image="onboarding-strategy"
            presentation="Onboarding Strategy"
            url="https://docs.google.com/presentation/d/1tqWOUX2PfqZTDWFRmh7-zpoEnzI5EJkFinW9pSwqWLQ/edit?usp=sharing"
          />
        </div>
        <div
          className={cx([
            "julia-website-portfolio",
            "u-flex",
            "u-flex-column",
            "u-padding-0point875rem",
          ])}
        >
          <Job
            image="active-listening-training"
            presentation="Active Listening Training"
            url="https://docs.google.com/presentation/d/1487iWz_Drwm0IYz0NKXK9iIICdQL5Mgqz72rfUlQw1Q/edit?usp=sharing"
          />
        </div>
        <div
          className={cx([
            "julia-website-portfolio",
            "u-flex",
            "u-flex-column",
            "u-padding-0point875rem",
          ])}
        >
          <Job
            image="change-management-strategy"
            presentation="Change Management Strategy"
            url="https://docs.google.com/presentation/d/1kNyi6EymOEmsgNo8YuMqUe16oBrd2tl7oNks3SshpBE/edit?usp=sharing"
          />
        </div>
        <div
          className={cx([
            "julia-website-portfolio",
            "u-flex",
            "u-flex-column",
            "u-padding-0point875rem",
          ])}
        >
          <Job
            image="intro-to-ai"
            presentation="Intro to AI"
            url="https://share.articulate.com/-TJmtoWB2O6WL0MC6FO5B"
          />
        </div>
        <div
          className={cx([
            "julia-website-portfolio",
            "u-flex",
            "u-flex-column",
            "u-padding-0point875rem",
          ])}
        >
          <Job
            image="giving-receiving-feedback"
            presentation="Giving and Receiving Feedback"
            url="https://share.articulate.com/a6BYd_9EB4lUJ5UFcDEJC"
          />
        </div>
      </div>
    </div>
  </Section>
);

export default React.memo(Portfolio);
